export default __webpack_public_path__ + "static/media/DP4 4A-2EC.303dc9e4.jpg";